@use "@fukuri-admins/ui/layout" as *;

.form {
  width: 100%;
}

.formContainer {
  max-width: 640px;
  width: 100%;
}

.titleRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.formTitle {
  @include typography('Jp/20_W6');
  margin: 0;
}

.guideLink {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.guideLinkIcon {
  color: text('Low');
}

// ラジオボタン(16px) + gap(8px) 分インデント
.scheduledDateTimeWrapper {
  padding-left: 24px;
}
